import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import { APP_COLORS } from 'src/global-styles';
import { SneOralCommunicationBase } from '../sne-oral-communcation.base';
import { SneVideoComponent } from '../../components/sne-video/sne-video.component';

@Component({
  selector: 'ets-multi-choice-full',
  templateUrl: './multi-choice-full.component.html',
  styleUrls: ['./multi-choice-full.component.scss']
})
export class MultiChoiceFullComponent extends SneOralCommunicationBase implements OnInit {

  constructor(router: Router, route: ActivatedRoute, protected sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }
  @ViewChild(SneVideoComponent) videoComp!:SneVideoComponent;
  
  headerState: HEADER_STATES = HEADER_STATES.BACK;
  APP_COLORS = APP_COLORS;
  showModal = false;
  

  toggleModal() {
    this.showModal = !this.showModal;
  }

  singleResponseHandler(answer: string) {
    this.singleResponse = answer;
  }

  multiResponseHandler(answer: string) {
    let arrIndex = this.multiResponse.indexOf(answer);
    if (arrIndex > -1) {
      // if answer is already in the array, remove it at arrIndex
      this.multiResponse.splice(arrIndex, 1);
    } else {
      this.multiResponse.push(answer);
      this.multiResponse.sort();
    }

  }

  ngOnInit() {
    this.processParams();
  }

  closeModal(){
    if (this.videoComp) {
      this.videoComp.onModalClose();
    }
    this.closeInstructionModal();
  }
}
